import React, {Suspense} from 'react';
import {connect} from 'react-redux';
import {
  BrowserRouter as Router,
  Switch
} from "react-router-dom";
import { Route } from "react-router"; 
import Header from './common/header/index';

import Loader from './common/elements/loader'

import AuthRoute from './common/elements/authRoute';
import PrivateRoute from './common/elements/privateRoute';

import Auth from 'view/public/auth/index'

import Administration from 'view/administration/index'

import Privacy from 'view/public/privacy'
import TOS from 'view/public/tos'
import Profiles from "view/riskDashboard/profiles";
import RiskDashboard from './riskDashboard';

function MainView (props) {
  
  return (
    <Router>
      <Header/>
      <div className="mainContent px-5 md:px-6 lg:px-7 xl:px-8 pt-3 pb-48 md:pb-40">
        <div className={`_border-b-2 border-uhnavy`}>
          <Suspense fallback={<Loader mainLoader={true} className={`small`}/>}>
            <Switch>
              
              <PrivateRoute path="/administration" loggedIn={props.authentication.loggedIn}>
                <Administration />
              </PrivateRoute>
              
               

              <PrivateRoute path="/risk" loggedIn={props.authentication.loggedIn}>
                <RiskDashboard />
              </PrivateRoute>

               

              <AuthRoute path="/auth" loggedIn={props.authentication.loggedIn}>
                <Auth />
              </AuthRoute>

              <Route path='/privacy'>
                <Privacy/>
              </Route>
              <Route path='/terms'>
                <TOS/>
              </Route>
              
              <PrivateRoute path="/" loggedIn={props.authentication.loggedIn}>
                <Profiles/>
              </PrivateRoute>
            </Switch>
          </Suspense>
        </div>
      </div>
      {/* <Footer/> */}
    </Router>  
  )
}

const mapStateToProps = state => ({
  authentication:state.authentication,
})

export default connect(mapStateToProps, {})(MainView);